/**
 * User-highlight color registry
 * ─────────────────────────────
 * The single source of truth for the colors a USER can apply with the editor's
 * highlighter (distinct from the auto-generated "generated content" yellow, which is a
 * separate mechanism - see `isDataDrivenSowToken` + `.dcv-gen`). A highlight is stored on
 * a text run as `TextRunDefinition.highlight = '<name>'`; each surface maps that name here:
 *   - web view + editor: a CSS custom property (theme-aware, defined in global.css)
 *   - Word (.docx):      a WordprocessingML highlight name
 *   - Google Docs:       a hex background color
 *
 * Adding a color later = one entry here + (web) one `--doc-hl-<name>-bg` token & a
 * `.dcv-hl--<name>` rule + one toolbar control. Yellow is the only color for now.
 */
export const HIGHLIGHT_COLORS = {
    yellow: { name: 'yellow', cssVar: '--doc-user-highlight-bg', docx: 'yellow', hex: 'FDD835' },
};
/** The color the single yellow toolbar button applies (and the default for a bare `==`). */
export const DEFAULT_HIGHLIGHT_COLOR = 'yellow';
/** Resolve a stored highlight name to its color, falling back to the default. */
export function highlightColor(name) {
    return (name && HIGHLIGHT_COLORS[name]) || HIGHLIGHT_COLORS[DEFAULT_HIGHLIGHT_COLOR];
}
//# sourceMappingURL=sow-highlight-colors.js.map